import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationBloc } from '@kp/auth/authentication.bloc';

@Component({
  selector: 'kp-modal-password-reset-required',
  templateUrl: './modal-password-reset-required.component.html',
  styleUrls: ['./modal-password-reset-required.component.scss'],
})
export class ModalPasswordResetRequiredComponent {
  @Input() email: string;
  @Input() returnUrl: string;
  @Output() closeClicked = new EventEmitter<boolean>();

  callInProgress = false;
  showError = false;

  constructor(private _router: Router, private _authenticationBloc: AuthenticationBloc) {}

  dismissModal() {
    this.closeClicked.emit(true);
  }

  resetPassword() {
    this._authenticationBloc.setChangePasswordReturnUrl(this.returnUrl);
    this._authenticationBloc.requestPasswordReset(this.email);
    void this._router.navigate(['/login/reset/password']);
  }
}
